export default () => {
    MyFacture.init();
};